import { notification } from 'antd'
import { CONFIG_URL } from '../helpers/constants'

const api = {
   URI_ENDPOINT: CONFIG_URL.SERVICE_URL,
   auth: {
      refreshToken: '/auth/refresh-tokens',
      login: '/auth/login',
      register: '/auth/register',
      getUserInfo: '/auth/getUserInfo',
      updateInfo: '/auth/updateInfo',
      changePassword: '/auth/changePassword',
      resetPassword: '/auth/reset-password',
      forgotPassword: '/auth/forgot-password',
      logout: '/auth/logout',
      verifyEmail: '/auth/verify-email',
      sendEmail: '/auth/send-verification-email'
   },
   user: {
      getProfile: '/profiles',
      updateProfile: '/profiles',
      changePassword: '/profiles/change-password',
      transaction: '/profiles/transaction'
   },
   upload: {
      uploadFile: '/upload'
   },
   productType: {
      getList: '/product-type',
      edit: '/product-type',
      create: '/product-type',
      delete: '/product-type'
   },
   designType: {
      getList: '/design-type',
      edit: '/design-type',
      create: '/design-type',
      delete: '/design-type'
   }, 
   job: {
      getList: '/job',
      // GET /job/export — file Excel theo bo loc, khong phan trang
      export: '/job/export',
      getDetail: '/job',
      lastJob: '/job/last-job',
      getFilterOption: '/listFilterOptions',
      receive: '/job/receive',
      reReceive: '/job/re-receive',
      review: '/job/review',
      designerUpdateUrl: '/job/designer-update',
      managerUpdate: '/job/manager-update',
      // POST /job/stitches/:jobId — designer cua viec nhap so mui theu
      updateStitches: '/job/stitches',
      updateNote1: '/job/note1',
      confirm: '/job/confirm',
      delete: '/job/delete',
      cancel: '/job/cancel',
      update: '/job/edit',
      updateImages: '/job/images',
      // POST /job/count/:jobId — sua so luong mau (khac GET /job/count)
      updateCount: '/job/count',
      addHashtag: '/job/hashtag',
      // POST /job/hashtag/:jobId/remove
      removeHashtag: '/job/hashtag',
      count: '/job/count',
      rate: '/job/rate',
      isReceive: '/job/is-receive',
      total: '/job/total',
      sameNumber: '/job/sample-number',
      assignee: '/job/assignee',
      priority: '/job/priority',
      countCancel: 'job/count-cancel',
      approve: '/job/approve',
      approveFinish: '/job/approve-finish',
      // Admin/supporter tra viec ve cho designer sua lai
      managerReject: '/job/manager-reject',
      // Goi y link thiet ke theo anh tuong tu: GET/refresh theo jobId, apply/reject theo suggestionId
      suggestions: '/job/suggestions',
      applySuggestion: '/job/suggestions/apply',
      rejectSuggestion: '/job/suggestions/reject'
   },
   hashtag: {
      search: '/hashtag'
   },
   exchangeFee: {
      getList: '/exchange-fee',
      getFeeInfo: '/exchange-fee', //{{url}}/v1/exchange-fee?designTypeId=1&productTypeId=2
      edit: '/exchange-fee',
      create: '/exchange-fee',
      delete: '/exchange-fee'
   },
   activityHistory: {
      getList: '/history'
   },
   groupChat: {
      getList: '/chat',
      sendMessage: '/chat/message',
      getListMessage: '/chat/message'
   },
   managerUser: {
      getUser: '/users',
      create: '/users',
      update: '/users',
      delete: '/users',
      transaction: '/users/transaction',
      trustUsers:'/users/trustUsers'
   },
   config: {
      create: '/config',
      update: '/config',
      getList: '/config',
      getListSupport: '/config/get-link-support'
   },
   debt: {
      getList: '/debts',
      total: 'debts/total'
   },
   funds: {
      create: '/funds',
      update: '/funds',
      approve: '/funds/approve',
      getList: '/funds',
      total: '/funds/total'
   },
   notification: {
      get: '/notifications',
      getListAdmin: '/notifications/admin',
      updateHighlightAdmin: '/notifications/hightlight',
      createAdmin: '/notifications',
      mark_read: '/notifications/mark-read'
   },
   dashboard: {
      jobFinish: "dashboard/job-finish",
      revenue: "dashboard/revenue",
   },
   apiKey: {
      getList: '/api-keys',
      create: '/api-keys',
      revoke: '/api-keys',
      delete: '/api-keys'
   }
}

export default api
